import { useMemo } from 'react';
import { APPLICATION_BREAKPOINTS, useWindowSize } from '@marriott/mi-ui-library';

export function useViewportCategory() {
  const { width } = useWindowSize();

  const sortedEntries = useMemo(() => {
    return Object.entries(APPLICATION_BREAKPOINTS).sort((a, b) => a[1] - b[1]);
  }, []);

  const currentViewport = useMemo(() => {
    let matchedKey = sortedEntries[0][0];

    if (!width) {
      return matchedKey;
    }

    for (let i = 0; i < sortedEntries.length; i++) {
      const [sortedKey, sortedValue] = sortedEntries[i];
      if (width >= sortedValue) {
        matchedKey = sortedKey;
      } else {
        break;
      }
    }

    return matchedKey;
  }, [sortedEntries, width]);

  return currentViewport;
}
